import { ArrowRight } from 'lucide-react';
import { PROFILES, type ProfileId, Eyebrow } from './types';

interface Step1ProfilProps {
  onSelect: (p: ProfileId) => void;
}

export function Step1Profil({ onSelect }: Step1ProfilProps) {
  return (
    <div>
      <Eyebrow>Étape 1 sur 5</Eyebrow>
      <h3 className="mt-2 h-section">
        Quel est votre profil ?
      </h3>
      <p className="mt-1.5 text-[13px] leading-relaxed text-stone-500">
        Vos droits aux primes CEE dépendent de votre statut. Choisissez pour personnaliser votre parcours.
      </p>

      <div className="mt-6 space-y-2.5">
        {PROFILES.map((p) => {
          const Icon = p.icon;
          return (
            <button
              key={p.id}
              onClick={() => onSelect(p.id)}
              className="group flex w-full items-center gap-4 rounded-xl border-2 border-stone-200 bg-white p-4 text-left transition-all duration-150 ease-out hover:border-brand-300 hover:bg-brand-50/30 hover:shadow-[0_4px_16px_rgba(16,185,129,0.07)] focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-brand-400 focus-visible:ring-offset-2"
            >
              <div className={`flex h-11 w-11 shrink-0 items-center justify-center rounded-xl transition-transform duration-150 ease-out group-hover:scale-105 ${p.iconBg}`}>
                <Icon className="h-5 w-5" strokeWidth={1.7} />
              </div>
              <div className="min-w-0 flex-1">
                <p className="text-[14px] font-semibold text-ink">{p.label}</p>
                <p className="mt-0.5 text-[12px] text-stone-500">{p.sublabel}</p>
              </div>
              <ArrowRight className="h-4 w-4 shrink-0 text-stone-300 transition-all duration-150 ease-out group-hover:translate-x-0.5 group-hover:text-brand-500" />
            </button>
          );
        })}
      </div>

      <p className="mt-5 text-[12px] text-stone-500">
        Particulier ?{' '}
        <a
          href="/particuliers/calculer-mes-aides"
          className="font-semibold text-brand-700 underline-offset-2 hover:underline"
        >
          Calculateur MaPrimeRénov’ + CEE →
        </a>
      </p>
    </div>
  );
}
